// Adressen voor de uitleg (golf 6a; nieuwe adressen 28 sep 2026): het bord woont bij de ouderapp.
// Productie: amumin.app → board.amumin.app (voorheen f.amumin.com → kiosk.f.amumin.com);
// dev: app.fb.localhost → kiosk.fb.localhost. Alleen voor de tekst in de stappen; de QR-koppeling
// krijgt het echte adres van de API (KIOSK_ORIGIN).

/** Het productie-adres van de ouderapp en van het bord (zonder https://). */
export const PROD_APP_HOST = 'amumin.app';
export const PROD_BOARD_HOST = 'board.amumin.app';

/** "board.amumin.app" bij "amumin.app"; valt terug op het productie-adres. */
export function kioskHost(appHost: string): string {
  const host = appHost.toLowerCase().replace(/:\d+$/, '');
  if (!host || host === 'localhost' || /^[\d.]+$/.test(host) || host.startsWith('[')) {
    return PROD_BOARD_HOST;
  }
  if (host.startsWith('kiosk.') || host.startsWith('board.')) return host;
  if (host.startsWith('app.')) return `kiosk.${host.slice('app.'.length)}`;
  // Een kaal domein (amumin.app): het bord op board.<domein>. Oude opzet (f.amumin.com): kiosk.
  if (host.split('.').length === 2) return `board.${host}`;
  return `kiosk.${host}`;
}

/** Het adres van de ouderapp zonder https:// ("amumin.app"). */
export function appHost(): string {
  return typeof window === 'undefined' ? PROD_APP_HOST : window.location.host;
}
